import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_creator_banner = _resolveComponent("creator-banner")
  const _component_creator_projects = _resolveComponent("creator-projects")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_creator_banner, _normalizeProps(_guardReactiveProps($options.creatorBannerModel)), null, 16 /* FULL_PROPS */),
    _createVNode(_component_creator_projects, { "creator-id": $options.creatorId }, null, 8 /* PROPS */, ["creator-id"])
  ]))
}